import { render, staticRenderFns } from "./Tracks.vue?vue&type=template&id=4c5fba34&scoped=true&"
import script from "./Tracks.vue?vue&type=script&lang=js&"
export * from "./Tracks.vue?vue&type=script&lang=js&"
import style0 from "./Tracks.vue?vue&type=style&index=0&id=4c5fba34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5fba34",
  null
  
)

export default component.exports